module.exports = __webpack_public_path__ + "static/media/1@960w.bb1fba6d.jpg";